export default ({ data }) => {
  return {
    text: data.text,
    footnote: data.footnote,
  };
};
